/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_PlansInputs */

const en_portalframe_plans = /** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans`)
};

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const ar_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const he_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const ur_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const es_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const fr_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const de_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const pt_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const hi_portalframe_plans = en_portalframe_plans;

/** @type {(inputs: Portalframe_PlansInputs) => LocalizedString} */
const bn_portalframe_plans = en_portalframe_plans;

/**
* | output |
* | --- |
* | "Plans" |
*
* @param {Portalframe_PlansInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_plans = /** @type {((inputs?: Portalframe_PlansInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_PlansInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_plans(inputs)
	if (locale === "he") return he_portalframe_plans(inputs)
	if (locale === "ur") return ur_portalframe_plans(inputs)
	if (locale === "es") return es_portalframe_plans(inputs)
	if (locale === "fr") return fr_portalframe_plans(inputs)
	if (locale === "de") return de_portalframe_plans(inputs)
	if (locale === "pt") return pt_portalframe_plans(inputs)
	if (locale === "hi") return hi_portalframe_plans(inputs)
	if (locale === "bn") return bn_portalframe_plans(inputs)
	return /** @type {LocalizedString} */ ("Plans")
});